import ApiValues from '../url/apiurl'
var axios = require('axios');
import labels from '../../utils/constants/labels';
import Networking from '../../utils/api/apiaccess';
function getPayment2FA(data) {
  // var data = JSON.stringify({"ClientCode":Clientcode,"LogoutURL":`${window.globalConfig.Domain6}/payment`});


  return Networking.PostApi(ApiValues.payment2FA, data,labels.apiKey.apiKeys).then(result => { return result })
    .catch(function (error) {
      return { "status": "F", "message": labels.messages.apierror }
    });

}
export default getPayment2FA
